<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex md10 offset-md1 xs12 offset-xs0 mb-2>
                <span class="green--text">Torneos</span>
                <span class="ml-3 mr-3">></span>
                <span>Nuevo Torneo</span>
                <span class="ml-3 mr-3">></span>
                <span>Captura de Resultados</span>

                <p class="green--text headline mb-0 mt-2">Jornadas</p>
            </v-flex>
        </v-layout>

        <v-layout row wrap mt-2>
            <v-flex md10 offset-md1 xs12 offset-xs0>
                <v-tabs>
                    <v-tabs-bar class="transparent" left>
                        <v-tabs-slider color="green"></v-tabs-slider>
                        <v-tabs-item
                            v-for="(set, i) in currentTournamentResults"
                            :key="'set' + i"
                            :href="'#set' + i"
                        >
                            <div @click="setCurrentSet(set)">
                                <p class="subheading mb-0">{{ dayFormat(set.start_date) }}</p>
                                <span>{{ set.type }}</span>
                            </div>
                        </v-tabs-item>
                    </v-tabs-bar>

                    <v-tabs-items :touchless="true">
                        <v-tabs-content v-for="(set, i) in currentTournamentResults"
                          :key="'set' + i"
                          :id="'set' + i">
                            <div class="matches-wrapper pt-3">
                                <p class="subheading mt-3 mb-2">Partidos</p>

                                <match-row v-for="(match, i) in set.matches"
                                    :key="match.id"
                                    :match="match"
                                    :disabled="currentTournament.status == 'finalized'"
                                    :tournamentid="currentTournament.id">
                                </match-row>
                            </div>
                        </v-tabs-content>
                    </v-tabs-items>
                </v-tabs>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import moment from 'moment'
  import MatchRow from './MatchRow'
    export default {
        name: "Scores",
        components: {
          MatchRow
        },
        data() {
            return {
              isOpen:true,

                headers: [
                    { text: 'Nombre', value: 'name', align: 'left' },
                    { text: 'Goles', value: 'goals' },
                    { text: 'Autogoles', value: 'autoGoals' },
                    { text: 'Tarjetas Amarillas', value: 'yellowCards' },
                    { text: 'Tarjetas Rojas (mg)', value: 'redCards' }
                ]
            }
        },
        created() {
          this.loadTournamentResults(this.currentTournament.id)
        },
        methods: {
          ...mapActions([
            'loadTournamentResults'
          ]),
          dayFormat(date) {
            var localLocale = moment(date);
            moment.locale('es');
            localLocale.locale(false);
              return localLocale.format('DD MMM').toUpperCase()
          },
          setCurrentSet(set){

          }
        },
        computed:{
          ...mapGetters([
            'currentTournament',
            'currentTournamentResults'
          ])
        }
    }
</script>

<style lang="css" scoped>
.matches-wrapper {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/scores/Scores.vue